import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Paper, View } from '@olxbr/design-system'

import EmailChangeSendMailTemplate from '../../templates/EmailChangeSendMailTemplate'
import medias from '../../../util/medias'

const CustomPaper = styled(Paper)`
  padding: 32px 64px;
`

const ContentWrapper = styled(View)`
  display: flex;
  flex-direction: column;
  margin: 64px auto;
  max-width: 466px;
  ${medias.small`
    margin-top: 24px;
    margin-bottom: 24px;
    margin-left: 0px;
    margin-right: 0px;
  `}
`

export const EmailChangeSendMailPage = ({ onCancel, onEmailSent, token }) => (
  <ContentWrapper>
    <CustomPaper>
      <EmailChangeSendMailTemplate onEmailSent={onEmailSent} token={token} onCancel={onCancel} />
    </CustomPaper>
  </ContentWrapper>
)

EmailChangeSendMailPage.propTypes = {
  onEmailSent: PropTypes.func,
  token: PropTypes.string,
  onCancel: PropTypes.func,
}
